/**
 * Módulo: IA
 *
 * IMPORTANTE — Este módulo NO tiene UI ni route propia. La IA es una capa
 * transversal: desde el Plan IA Paso 7 su gobierno está consolidado en la
 * sección /ia (Panel, Prompts, Reuniones, Motor, Credenciales, Pricing, Seeds,
 * Salud); la IA que produce valor está embebida en cada módulo (reuniones en
 * la ficha de empresa, preguntas/opiniones en el dashboard de Mercado Libre).
 *
 * Este módulo existe como **ítem contratable del plan**: un plan lo incluye —o
 * no— en `modulosIncluidos`, y el backend (`aiQuota.chequearCuota`) gatea toda
 * llamada de IA de la empresa contra eso (motivo 'modulo-ia-inactivo'). El
 * frontend esconde los botones de IA cuando la empresa no tiene el módulo.
 *
 * Plan IA, Paso 2c — ver docs/explicacion/norte/roadmap.md.
 */
export default {
  id: 'ia',
  nombre: 'IA',
  descripcion: 'Habilita la asistencia de IA de la empresa (reuniones, preguntas, opiniones, señales).',
  icono: 'brain',
  tipo: 'operativo',
  version: '0.1.0',

  // No tiene rutas ni menuItems propios — la IA está embebida en otros módulos.
  routes: [],
  menuItems: [],

  features: [
    'ia-reuniones',
    'ia-preguntas',
    'ia-opiniones',
    'ia-senales',
  ],

  // Vacío a propósito: la IA no se gatea por rol — se gatea por plan
  // (`modulosIncluidos`). El gobierno de plataforma vive en /ia con su propio
  // `permisoModulo: 'ia-config'`. No queremos un ítem de sidebar para esto.
  permisoModulos: [],

}
